module.exports = __webpack_public_path__ + "assets/2a15272e985409089d506c9bf612f6a9.svg";


//////////////////
// WEBPACK FOOTER
// ./app/reports/assets/reports.svg
// module id = 742
// module chunks = 0